import { persistStateTypes } from 'a/reducers/persistStateReducer';
import {
  GAME_ID,
  REDUX_ACTIONS,
  ONBOARDING_LEVEL_ID,
  IS_INTERMEDIATE_SAVING_DISABLED,
  CURRENT_SAVE_DATA_VERSION,
} from '../../data/constants';

const initialState = {
  isLoaded: false,
  isQuestWorkflow: true,
  savedFiles: {},
};

const saveDataReducer = (state = initialState, action) => {
  if (action.type === 'SELECT_ACTIVITY') {
    return {
      ...state,
      isQuestWorkflow: !!action.payload.isQuestWorkflow,
    };
  }

  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        isLoaded: true,
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      let savedFiles = { ...state.savedFiles };
      const { GameData } = action.stateData[GAME_ID];

      if (GameData === undefined || IS_INTERMEDIATE_SAVING_DISABLED) {
        return {
          ...state,
          isLoaded: true,
        };
      }

      // ignore any old save files that are no longer compatible with the current client code.
      if (GameData.version === undefined || GameData.version < CURRENT_SAVE_DATA_VERSION) {
        return {
          ...state,
          isLoaded: true,
        };
      }

      if (GameData.savedFiles !== undefined) {
        savedFiles = { ...savedFiles, ...GameData.savedFiles };
      }

      return {
        ...state,
        isLoaded: true,
        savedFiles,
      };
    }

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM: {
      const {
        levelId,
        assignmentId,
        supportsIntermediateSave,
        completedItemIndex,
        lastPoV,
        correctAnswers,
        masteredItemsCount,
        isLeavingFinalQuestion,
        records,
      } = action.payload;

      // we don't want to save the user's position in onboarding. That always starts from square 1.
      // we also don't want to save if saving is disabled.
      if (levelId === ONBOARDING_LEVEL_ID || IS_INTERMEDIATE_SAVING_DISABLED || isLeavingFinalQuestion) {
        return state;
      }

      if (!supportsIntermediateSave) {
        return state;
      }

      const newSavedFiles = { ...state.savedFiles };

      const newSavedFileData = {
        ...newSavedFiles[levelId],
        lastCompletedItem: completedItemIndex,
        lastPoV,
        correctAnswers,
        masteredItemsCount,
        records,
      };

      if (assignmentId) {
        newSavedFiles[assignmentId] = { [levelId]: newSavedFileData };
      } else {
        newSavedFiles[levelId] = newSavedFileData;
      }

      return {
        ...state,
        savedFiles: newSavedFiles,
      };
    }

    case REDUX_ACTIONS.CLEAR_SAVED_DATA_BY_KEY: {
      const { key } = action.payload;

      const newSavedFiles = { ...state.savedFiles };
      delete newSavedFiles[key];

      return {
        ...state,
        savedFiles: newSavedFiles,
      };
    }

    default:
      return state;
  }
};

export default saveDataReducer;
